<template>
    <div class="honor">
       <div class="title wow fadeInUp">
           {{$t('home').honor.text0}}
       </div>
        <div class="allImgs wow fadeInUp">
            <swiper class="swiper" :options="swiperOption" ref="mySwipers">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                 <div class="one">
                     <img :src="`http://www.uni-sec.com/${item.picurl}`" alt="">
                 </div>
                </swiper-slide>
            </swiper>
            <swiper class="swiper swiper2" :options="swiperOption2" ref="mySwipers2">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div class="one">
                        <img :src="`http://www.uni-sec.com/${item.picurl}`" alt="">
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-pagination" slot="pagination"></div>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "honor",
        data(){
            return{
                swiperOption:{
                    notNextTick: true,
                    slidesPerView:6,//一行显示3个
                    slidesPerColumn: 2,//显示2行
                    speed:1000,
                    init:true,
                    loop:false,
                    spaceBetween :10,
                    setWrapperSize :true,
                    autoplay: false,
                    pagination: {
                        el: '.allImgs .swiper-pagination',
                        clickable: true
                    }
                },
                swiperOption2:{
                    notNextTick: true,
                    slidesPerView:1,//一行显示3个
                    slidesPerColumn: 1,//显示2行
                    speed:1000,
                    init:true,
                    loop:false,
                    spaceBetween :10,
                    setWrapperSize :true,
                    autoplay: true,
                    pagination: {
                        el: '.allImgs .swiper-pagination',
                        clickable: true
                    }
                }
            }
        },
        props:['list'],
        components:{
            swiper, swiperSlide
        }
    }
</script>

<style lang="scss" scoped>
.honor{
    width:80%;
    margin: 60px auto;
    animation-duration: 3s;
    .title{
        font-size: 50px;
        color:#263346;
        font-family: "DINEngschriftStd";
        text-transform: uppercase;
        text-align: center;
    }
    .allImgs{
        width:100%;
        margin: 60px auto;
        position: relative;
        padding: 60px 0;
        .swiper{
            width:100%;
            .item{
                cursor: pointer;
                .one{
                    border: 1px solid #DFDFDF;
                    text-align: center;
                    padding: 20px 0;
                    height:73px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                    img{
                        transition: all 600ms;
                        max-width: 100%;
                        object-fit: cover;
                    }
                    &:hover{
                        img{
                            transform: scale(1.05);
                        }
                    }
                }
            }
        }
        .swiper2{
            display: none;
        }
    }
    @media screen and (max-width: 1440px){
        width:90%;
        margin: 30px auto;
        .content{
            flex-direction: column;
            .item{
                width:100%;
                margin-top: 30px;
            }
        }
    }
    @media screen and (max-width: 1000px){
     .title{
         font-size: 30px;
     }
        .allImgs{
            margin: 0 auto;
            .swiper{
                display: none;
            }
            .swiper2{
                display: block;
            }
        }
    }
}
</style>
<style scoped>
    .allImgs .swiper-pagination{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        bottom:0;
        left:0;
    }
    .allImgs .swiper-pagination>>>.swiper-pagination-bullet {
        width:8px;
        height:8px;
        background:transparent;
        margin-left: 30px;
        position: relative;
        border-radius: 50%;
        opacity: 1 ;
        transition: all 600ms;
        border: 1px solid #263346;
    }
    .allImgs .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .allImgs .swiper-pagination>>>.swiper-pagination-bullet-active{
        background-color: #263346;
    }
</style>
